import { createStyles } from '@mantine/core';
var useStyles = createStyles(function (theme, _ref) {
  var color = _ref.backgroundColor;
  return {
    root: {
      fontFamily: '"Shentox", "Rogan", "sans-serif"',
      position: "relative",
      textTransform: "uppercase",
      border: "none",
      padding: "10px 30px",
      height: "60px",
      fontSize: "18px",
      letterSpacing: "0.02em",
      minWidth: "220px",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      overflow: "hidden",
      lineHeight: "0",
      fontWeight: 600,
      backgroundColor: color,
      color: "black",
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: "color 0.2s ease-in-out 0s",
      "&:before": {
        content: '""',
        position: "absolute",
        backgroundColor: color,
        top: "0px",
        left: "0px",
        width: "115%",
        height: "102%",
        filter: "brightness(0.95)",
        opacity: "0",
        transform: "translate3d(-100%, 0, 0)",
        transition: "transform 0.4s ease, opacity 0.4s ease",
        clipPath: "polygon(0 0, 100% 0%, calc(100% - 20px) 100%, 0% 100%)"
      },
      "&:hover:before": {
        opacity: "1",
        transform: "translate3d(0px, 0px, 0px)"
      },
      "&:hover": {
        backgroundColor: color
      },
      span: {
        position: "relative"
      }
    },
    icon: {},
    leftIcon: {},
    rightIcon: {},
    inner: {},
    label: {},
    cutoutBottom: {
      clipPath: "polygon(0% 0px, 0px 0%, 100% 0%, 100% 0px, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0px 100%, 0% calc(100% - 8px))"
    },
    cutoutNone: {
      clipPath: "none"
    },
    cutoutTop: {
      clipPath: "polygon(0% 0px, 0px 0%, calc(100% - 8px) 0%, 100% 8px, 100% 100%, 0% 100%)"
    }
  };
});
export { useStyles as default };